import "%blocks%/header/header.js";
import "%blocks%/mobile-menu/mobile-menu.js";
import "%blocks%/results/results.js";
import "%blocks%/prices/prices.js";
import "%blocks%/services/services.js";
import "%blocks%/faq/faq.js";
import "%blocks%/popups/popups.js";
import "%blocks%/form/form.js";
